// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"90e49080","464":"414df554","486":"18cca6b5","554":"2373c77f","717":"22265651","936":"8d3fbc49"}[chunkId] + ".chunk.js";
};